import { extend, localize } from 'vee-validate'
import {
  required as rule_required,
  email as rule_email,
  min as rule_min,
  confirmed as rule_confirmed,
  regex as rule_regex,
  between as rule_between,
  alpha as rule_alpha,
  integer as rule_integer,
  digits as rule_digits,
  alpha_dash as rule_alpha_dash,
  alpha_num as rule_alpha_num,
  length as rule_length,
  max as rule_max
} from 'vee-validate/dist/rules'
import ar from 'vee-validate/dist/locale/ar.json'
import en from 'vee-validate/dist/locale/en.json'

// eslint-disable-next-line object-curly-newline
import { validatorPositive, validatorUrlValidator, validatorPassword, validatorCreditCard, validatorMaxCaracteres,montoMax, validatorTelefono, validatorTelefonoLocal } from './validators'

// ////////////////////////////////////////////////////////
// General
// ////////////////////////////////////////////////////////

export const required = extend('required', {
  ...rule_required,
  message: 'Este campo es requerido'
})

export const email = extend('email', {
  ...rule_email,
  message:'El campo de correo electrónico debe ser un correo electrónico válido'
})

export const min = extend('min', { ...rule_min, 
  message:'Sú {_field_} no debe ser menor a {length} carácteres'
  }
)

export const max = extend('max', {
  ...rule_max,
  message:'Sú {_field_} no debe ser mayor a {length} caracteres.'
})

export const comision = extend('comision',{
  validate: (value, args) => (Number(value) >= args.minimo && Number(value) <= args.maximo ),
  params:['minimo','maximo'],
  message: 'Sú {_field_} debe estar entre {minimo} y {maximo} %'

})

export const confirmed = extend('confirmed', rule_confirmed)

export const regex = extend('regex', rule_regex)

export const between = extend('between', rule_between)

export const alpha = extend('alpha', rule_alpha)

export const integer = extend('integer', rule_integer)

export const digits = extend('digits', rule_digits)

export const alphaDash = extend('alpha-dash', rule_alpha_dash)

export const alphaNum = extend('alpha-num', rule_alpha_num)

export const length = extend('length', rule_length)

export const positive = extend('positive', {
  validate: validatorPositive,
  message: 'Please enter positive number!',
})

export const credit = extend('credit-card', {
  validate: validatorCreditCard,
  message: 'It is not valid credit card!',
})

export const password = extend('password', {
  validate: validatorPassword,
  message: 'Tu {_field_} debe contener al menos una mayúscula, una minúscula, un carácter especial y un dígito',
})

export const url = extend('url', {
  validate: validatorUrlValidator,
  message: 'URL is invalid',
})


export const mountMax = extend('mountMax',{
  validate:montoMax,
  params:['monto'],
  message:'El monto debe ser menor'
});

export const phone = extend('phone', {
  validate: validatorTelefono,
  message: 'El código de país es obligatorio y el número debe ser válido (Ej: +521234567890)',
})

export const phone_local = extend('phone_local', {
  validate: validatorTelefonoLocal,
  message: 'El número local debe ser de 7 a 12 dígitos y no incluir el código de país.',
})

// export const max = ext('max',{
//   validate: validatorMaxCaracteres,
//   message:"La {_field_} no debe tener mas de "
// })

// Install English and Arabic localizations.
localize({
  en: {
    messages: en.messages,
    names: {
      email: 'Email',
      password: 'Password',
    },
    fields: {
      password: {
        min: '{_field_} is too short, you want to get hacked?',
      },
    },
  },
  ar: {
    messages: ar.messages,
    names: {
      email: 'البريد الإلكتروني',
      password: 'كلمة السر',
    },
    fields: {
      password: {
        min: 'كلمة السر قصيرة جداً سيتم اختراقك',
      },
    },
  },
})
